import { VMSMappedObjectConstantsType } from "@/constants";
import { useConstants } from "./useConstants";

export const  useMappedConstants = (): VMSMappedObjectConstantsType => {
  const mappedConstants = useConstants("MAPPED") as VMSMappedObjectConstantsType;
  return mappedConstants;
};
